// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"fe8dd673","603":"c643b670","648":"1c723671","664":"967341f8","817":"1f8d67a4","845":"4b3fbf09"}[chunkId] + ".css";
};